/* eslint-disable */
import { ConfiguratorBuilder } from '@salsita-ai/platform-project-sdk/domain'

import { adminGeneratedComponents } from './admin-components/index.js'
import * as AdminEnhancenModel from './admin-enhanced-model.js'
import {
  attachAdminComponent,
  createAdminRecipe,
  createMapPublishedChunkedDataHandler,
  createMapPublishedRevisionDataHandler,
  implementAdminCustomExpressions,
  implementCustomAdminInvariants,
} from './admin-implementation.js'
import * as AdminModel from './admin-model/index.js'
import { generatedAdminPresets } from './admin-presets.js'
import {
  $dataSpec,
  AdminNavigationState,
  AdminViewState,
  ApplicationVersion,
  CallbackData,
  ExportState,
  FinalizeData,
  FinalizeResult,
  NavigationState,
  PrefetchedFinalizeData,
  PublishedDataHash,
  ToolState,
  ViewState,
} from './application-types.js'
import * as ApplicationTypes from './application-types.js'
import { generatedComponents } from './components/index.js'
import * as EnhancedModel from './enhanced-model.js'
import {
  attachComponent,
  createRecipe,
  implementCustomExpressions,
  implementCustomInvariants,
} from './implementation.js'
import * as Model from './model/index.js'
import { generatedPresets } from './presets.js'

export const generatedConfiguratorBuilder = new ConfiguratorBuilder({
  componentOptics: generatedComponents,
  adminComponentOptics: adminGeneratedComponents,
})
  .withPrefetchedFinalizeData(PrefetchedFinalizeData)
  .withFinalizeData(FinalizeData)
  .withFinalizeResult(FinalizeResult)
  .withNavigationState(NavigationState)
  .withViewState(ViewState)
  .withToolState(ToolState)
  .withExportState(ExportState)
  .withCallbackData(CallbackData)
  .withAdminNavigationState(AdminNavigationState)
  .withAdminViewState(AdminViewState)
  .withDataSpec($dataSpec)
  .withPublishedDataHash(PublishedDataHash)
  .withVersion(ApplicationVersion)
  .withPresets(generatedPresets)
  .withAdminPresets(generatedAdminPresets)
  .withChunks({ pricing: { scope: 'public' }, system: { scope: 'public' } })

export * as AdminEnhancedModel from './admin-enhanced-model.js'
export * as AdminModel from './admin-model/index.js'
export * as ApplicationTypes from './application-types.js'
export * as EnhancedModel from './enhanced-model.js'
export * as Model from './model/index.js'

// @ts-ignore - Initialize the globals
if (!globalThis.phx) {
  // @ts-ignore - Initialize the globals
  globalThis.phx = {}
}

// @ts-ignore - Initialize the globals
globalThis.phx.applicationTypes = ApplicationTypes

// @ts-ignore - Initialize the globals
globalThis.phx.domain = {
  model: Model,
  enhancedModel: EnhancedModel,

  implementCustomInvariants: implementCustomInvariants,
  implementCustomExpressions: implementCustomExpressions,
  createRecipe: createRecipe,
  attachComponent: attachComponent,

  admin: {
    model: AdminModel,
    enhancedModel: AdminEnhancenModel,

    implementCustomInvariants: implementCustomAdminInvariants,
    implementCustomExpressions: implementAdminCustomExpressions,
    createRecipe: createAdminRecipe,
    attachComponent: attachAdminComponent,
    createMapPublishedRevisionDataHandler: createMapPublishedRevisionDataHandler,
    createMapPublishedChunkedDataHandler: createMapPublishedChunkedDataHandler,
  },
}
